<!-- pointerdown alongside mousemove: touch taps don't produce reliable
     mousemove, and the auto-hidden controls must be recoverable on phones. -->
<div
  class="video-fullscreen"
  (mousemove)="onMouseMove()"
  (pointerdown)="onMouseMove()"
  (click)="onRootClick($event)">
  <div class="close-btn {{ controlsVisible() ? 'visible' : '' }}">
    <andor-icon-btn (clickHandler)="close.emit()">
      <fa-duotone-icon [icon]="faCompressWide"></fa-duotone-icon>
    </andor-icon-btn>
  </div>
  @if (user$ | async; as user) {
    <div
      class="video-tile {{ user.isSelf ? 'self' : '' }} {{
        streamMain().stream ? 'has-video' : ''
      }}">
      @if (!streamMain().stream && !streamSmall().stream) {
        <andor-user-avatar
          [user]="user"
          [scale]="3.0"
          [showStatus]="false"
          [showActivity]="false"></andor-user-avatar>
      }
      @if (streamMain().stream; as stream) {
        @if (stream | nativeVideo) {
          <canvas class="{{ streamMain().class }}" [andorVideoMount]="stream"></canvas>
        } @else {
          <video
            class="{{ streamMain().class }}"
            [srcObject]="stream"
            preload="none"
            autoplay
            playsinline
            disablePictureInPicture
            muted></video>
        }
      }
      @if (streamSmall().stream) {
        <div class="overlay">
          <div class="video-nav" cdkDragBoundary=".overlay" cdkDrag>
            @if (streamSmall().stream | nativeVideo) {
              <canvas
                class="{{ streamSmall().class }}"
                [andorVideoMount]="streamSmall().stream"></canvas>
            } @else {
              <video
                class="{{ streamSmall().class }}"
                [srcObject]="streamSmall().stream"
                preload="none"
                autoplay
                playsinline
                disablePictureInPicture
                muted></video>
            }
            <div class="user-actions">
              <andor-icon-btn
                [aria-label]="'Swap videos' | translate"
                (clickHandler)="swapStreams(user)">
                <fa-icon [icon]="faRepeat"></fa-icon>
              </andor-icon-btn>
            </div>
          </div>
        </div>
      }
    </div>
    @if (user.data.hasRaisedHand) {
      <andor-raised-hand-badge class="hand-pill"></andor-raised-hand-badge>
    }
    <div class="name-pill" [class.lifted]="controlsVisible()">
      <andor-mute-status [user]="user"></andor-mute-status>
      <andor-user-name [user]="user"></andor-user-name>
    </div>
  } @else {
    <div>{{ 'Loading...' | translate }}</div>
  }
  <div class="conferencing-controls {{ controlsVisible() ? 'visible' : '' }}">
    <andor-dock></andor-dock>
  </div>
</div>
